enum ESpecialChar {
    EmptySpace = "emptySpace",
    Comma = "comma",
    Ampersand = "ampersand",
    Hyphen = "hyphen",
    Dot = "dot",
    QuestionMark = "questionMark",
    ExclamationMark = "exclamationMark",
    Cross = "cross",
    Colon = "colon",
    Percent = "percent",
    CheckMark = "checkMark",
    OpeningBracket = "openingBracket",
    ClosingBracket = "closingBracket",
    Asterisk = "asterisk",
    Dash = "dash",
    Plus = "plus",
    Minus = "minus",
    Ellipsis = "ellipsis",
    CommercialAt = "commercialAt"
}

export { ESpecialChar }
